const hasNoBackgroundColor = backgroundColorField => (backgroundColorField?.hex
    ? ((backgroundColorField?.hex.length === 9
            && backgroundColorField?.hex[7] === 0
            && backgroundColorField?.hex[8] === 0)
            || backgroundColorField.hex === '#FFFFFF') : true);

export default hasNoBackgroundColor;
